import template from './configuration.html'
import controller from './configuration.controller'
import './configuration.scss'

const configurationComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default configurationComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/configuration/configuration.component.js